import Vue from 'vue';
import Router, { Route } from 'vue-router';
import {getLocalStorage} from '@/utils/local-storage';
import {initWeChat} from '@/utils/init-wechat';
import wx from 'wx-jssdk-ts';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/views/home/Home.vue'),
    },
    {
      path: '/news',
      component: () => import('@/views/news/News.vue'),
    },
    {
      path: '/news-article',
      component: () => import('@/views/news-article/NewsArticle.vue'),
    },
    {
      path: '/root-col',
      component: () => import('@/views/root-col/RootCol.vue'),
    },
    {
      path: '/advise',
      component: () => import('@/views/advise/Advise.vue'),
    },
  ],
});

router.afterEach((to, from) => {
  console.log(to);
  if (to.path != '/') {
    initWeChatSetting(to);
  }
});

export function setShare(route: Route) {
  const localStorageData = getLocalStorage();
  const {wxUserInfo, companyInfo} = localStorageData;

  if (wxUserInfo) {
    const {companyKey} = wxUserInfo;
    const urlObject = new URL(`${VUE_APP_BASE_API}/wx-interface-web/wx/auth`);
    urlObject.searchParams.set('companyKey', companyKey);
    urlObject.searchParams.set('page', 'wx_website');

    if (route.path != '/') {
      urlObject.searchParams.set('childPage', JSON.stringify({
        path: route.path,
        params: route.params,
        query: route.query,
      }));
    }

    if (companyInfo) {
      wx.updateAppMessageShareData({
        title: companyInfo.webTitle,
        desc: companyInfo.webTitle,
        link: window.encodeURI(urlObject.href),
        imgUrl: companyInfo.imgUrl,
        success() {
          // 设置成功
        },
        cancel() {
          // 取消
        },
      });
    } else {
      wx.updateAppMessageShareData({
        title: '',
        desc: '',
        link: window.encodeURI(urlObject.href),
        imgUrl: '',
        success() {
          // 设置成功
        },
        cancel() {
          // 取消
        },
      });
    }

    console.log(urlObject.href);
  }
}

export async function initWeChatSetting(to: Route) {
  await initWeChat();

  wx.hideMenuItems({
    menuList: [
      'menuItem:copyUrl',
      'menuItem:openWithQQBrowser',
      'menuItem:share:qq',
      'menuItem:share:weiboApp',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:share:timeline',
      'menuItem:favorite',
      'menuItem:openWithQQBrowser',
      'menuItem:openWithSafari',
      'menuItem:share:email',
      'menuItem:share:brand',
    ],
  });

  setShare(to);
}

export default router;
